import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UserFacade } from '@library/store/user/user.facade';
import { getUser } from '@library/store/user/user.selector';
import { select } from '@ngrx/store';
import { WeathermapFacade } from '@store/weathermap.facade';
import { combineLatest, combineLatestWith, map } from 'rxjs';

@Injectable()
export class WeathermapUserFacade extends UserFacade {
  private readonly weathermapFacade = inject(WeathermapFacade);

  units$ = combineLatest({
    unit_system: toObservable(this.weathermapFacade.unitSystem),
    unit_wind: toObservable(this.weathermapFacade.windUnit),
    unit_pressure: toObservable(this.weathermapFacade.pressureUnit),
  });

  currentUser$ = this.store.pipe(select(getUser)).pipe(
    combineLatestWith(this.units$),
    map(([user, units]) => {
      return {
        ...user,
        ...units,
      };
    }),
  );
}
